"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameOverlay = exports.GameOverlayProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_dom_1 = require("react-dom");
const GameOverlayTargetContext = (0, react_1.createContext)(null);
function GameOverlayProvider({ target, children }) {
    return ((0, jsx_runtime_1.jsx)(GameOverlayTargetContext.Provider, { value: target, children: children }));
}
exports.GameOverlayProvider = GameOverlayProvider;
function GameOverlay({ children }) {
    const target = (0, react_1.useContext)(GameOverlayTargetContext);
    return target ? (0, react_dom_1.createPortal)(children, target) : null;
}
exports.GameOverlay = GameOverlay;
